import request from '@/sheep/request';

// 自律项分类
export interface LimitCategory {
	id : number
	parentId ?: number
	name ?: string
	icon ?: string
	picUrl ?: string
	bgColor ?: string
	isShow ?: boolean
	status ?: number
	sort ?: number
	createTime ?: any
}

// 自律项分类精简
export interface LimitCategorySimple {
	id : number
	name ?: string
	icon ?: string
	isShow ?: boolean
	status ?: number
}

// 创建自律项分类
export const createLimitCategory = async (data : Partial<LimitCategory>) => {
	return request({
		url: '/wish/limit-category/create',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '创建成功'
		},
	});
}

// 更新自律项分类
export const updateLimitCategory = async (data : Partial<LimitCategory>) => {
	return request({
		url: '/wish/limit-category/update',
		method: 'PUT',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '更新成功'
		},
	});
}

// 删除自律项分类
export const deleteLimitCategory = async (id : number) => {
	return request({
		url: '/wish/limit-category/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 批量删除自律项分类
export const deleteLimitCategoryList = async (ids : number[]) => {
	return request({
		url: '/wish/limit-category/delete-list',
		method: 'DELETE',
		params: { ids },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 获得自律项分类
export const getLimitCategory = async (id : number) => {
	return request({
		url: '/wish/limit-category/get',
		method: 'GET',
		params: { id },
		custom: {
			auth: true
		},
	});
}

// 获得自律项分类分页
export const getLimitCategoryPage = async (params : any) => {
	return request({
		url: '/wish/limit-category/page',
		method: 'GET',
		params,
		custom: {
			auth: true
		},
	});
}

// 获取分类精简信息列表
export const getLimitCategorySimpleList = async () => {
	return request({
		url: '/wish/limit-category/list-simple',
		method: 'GET',
		custom: {
			auth: false
		},
	});
}

// 获取分类信息列表
export const getLimitCategoryList = async () => {
	return request({
		url: '/wish/limit-category/list',
		method: 'GET',
		custom: {
			auth: false
		},
	});
}

// 批量更新分类排序和权重
export const batchUpdateLimitCategorySortWeight = async (list : Partial<LimitCategory>[]) => {
	return request({
		url: '/wish/limit-category/batch-update-sort-weight',
		method: 'PUT',
		data: list,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '排序更新成功'
		},
	});
}